import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import { appMode } from '@/utils/config/mode'
import errorHandler from './errorHandler'
import globalGuards from './globalGuards'
import { setRouter } from './holder'
import routes from './routes'

const router = createRouter({
  history: appMode.isTest
    ? createMemoryHistory()
    : createWebHistory(window.__DYNAMIC_BASE__),
  linkActiveClass: 'router-link-active',
  routes: routes ?? [],
})

setRouter(router)

const { beforeEach, afterEach } = globalGuards()
beforeEach.forEach((params) => router.beforeEach(params))
afterEach.forEach((params) => router.afterEach(params))

router.onError(errorHandler)

export default router
